/* eslint-disable no-console */
// import * as appManager from './vendor/appManager'
import {register} from 'register-service-worker'
// TODO activate for online push
import {initMessaging} from "./firebase/firebaseUtil";
import {ebus} from './vendor/ebus';
import {getErrorDetails} from "./util/globalErrorHandler";

//https://github.com/vuejs/vue-cli/blob/dev/packages/%40vue/cli-plugin-pwa/generator/template/src/registerServiceWorker.js

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready(swRegistration) {
      console.log('Service worker is ready.');
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      );
      console.log('Do we have a swRegistration in ready here ???? ' + swRegistration);
      if (swRegistration) {
        // setTimeout(()=>{
        initMessaging(swRegistration);
        // },3000);
      }
    },
    registered(swRegistration) {
      console.log('Service worker has been registered. ');

      // console.log('Do we have a swRegistration in registered here ???? '+swRegistration);
      // if(swRegistration){
      //     // setTimeout(()=>{
      //         initMessaging(swRegistration);
      //     // },3000);
      // }

      // appManager.setSwReg(registration);
      // ebus.$emit('swRegistration', registration);

      // Routinely check for app updates by testing for a new service worker.
      // setInterval(() => {
      //   console.log('interval check for service worker update');
      //   registration.update();
      // }, 1000 * 60 * 60); // hourly checks
    },
    cached(swRegistration) {
      console.log('Service worker cached');
      // console.log('Content has been cached for offline use.')

      //The very first time the app loads 2 events are fired in row: cached and then registered.
      // We need only registered

      // console.log('Do we have a swRegistration in cached here ???? '+swRegistration);
      // if(swRegistration){
      //   // setTimeout(()=>{
      //   initMessaging(swRegistration);
      //   // },3000);
      // }
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated(swRegistration) {
      console.log('New content is available; please refresh.');
      try {
        // https://web.dev/two-way-communication-guide/
        swBus = new BroadcastChannel('swBus');
        swBus.postMessage({
          forwardEmit: true,
          address: 'pwaUpdateAvailable',
          params: {pwaUpdateAvailable: true},
        });
        // localStorage.setItem('shouldReload', 'true');
      } catch (e) {

      }
      // console.log('Send postMessage SKIP_WAITING');
      // navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING'});
      // console.log('After postMessage SKIP_WAITING');

      ebus.$emit('NewContentAvailable');

      // console.log('Do we have a swRegistration in updated here ???? '+swRegistration);
      // if(swRegistration){
      //   // setTimeout(()=>{
      //   initMessaging(swRegistration);
      //   // },3000);
      // }
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      let eMsg = 'Error during service worker registration: ';
      console.error(eMsg+' '+ error.message);
      // alert(eMsg);
      ebus.$emit('throwError', getErrorDetails(error, 'serviceWorker', eMsg))
    }
  })
}
